import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "./http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../models/base-response";
import {Feedback} from "../models/feedback";

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`FeedbackService`);
  }

  baseUrl = environment.apiUrl;

  adicionar(request: Feedback): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Feedback`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  listar(): Observable<BaseResponse<Feedback[]> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<Feedback[]>>(`${this.baseUrl}/Feedback/BuscarPorStatus/0`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('listar')));
  }

}
